export default {
  emmitedCountry: 'El Salvador y Estados Unidos'
}
